import {ajax as Ajax} from "rxjs/ajax";
import Cookies from 'js-cookie';

const getHeadersPos = (ajaxMethod) => {
    switch (ajaxMethod) {
        case 'get':
        case 'getJSON':
        case 'delete':
            return 1;
        case 'patch':
        case 'post':
        case 'put':
            return 2;
        default:
            return -1;
    }
};

const getDefaultHeaders = () => {
    const token = Cookies.get('x-xsrf-token');
    // Only emit the header when we actually have a value. Spreading
    // `{'x-xsrf-token': undefined}` makes some XHR implementations send the
    // literal string "undefined", which then fails CSRF validation server-side
    // for a different reason than "missing header".
    return token ? {'x-xsrf-token': token} : {};
};

// Wraps `rxjs/ajax`'s `ajax` so default headers (currently the CSRF token
// from `js-cookie`) are merged into every outgoing request, regardless of
// which call shape the consumer uses:
//
//   ajax.post(url, body, headers)        ← `get` trap intercepts the method
//   ajax.get(url, headers)                  property access and merges into
//   ajax.put / patch / delete / getJSON     `headers` at the right position
//
//   ajax({method, url, body, headers})   ← `apply` trap intercepts the
//                                            callable form and merges into
//                                            `config.headers`
//
// Without the `apply` trap, the second form bypassed default headers
// entirely - which is what the old `fixme` comment was warning about.
const ajaxProxy = (getDefaultHeadersFn = () => ({})) => (obj) =>
    new Proxy(obj, {
        apply(target, thisArg, args) {
            const [config] = args;
            if (config && typeof config === 'object') {
                args[0] = {
                    ...config,
                    headers: {...config.headers, ...getDefaultHeadersFn()}
                };
            }
            return Reflect.apply(target, thisArg, args);
        },
        get(target, propKey) {
            const origProp = target[propKey];
            const headersPos = getHeadersPos(propKey);
            if (headersPos === -1 || typeof origProp !== 'function') {
                return origProp;
            }
            return function (...args) {
                args[headersPos] = {...args[headersPos], ...getDefaultHeadersFn()};
                return origProp.apply(this, args);
            };
        }
    });

const ajax = ajaxProxy(getDefaultHeaders)(Ajax);
export default ajax;
